import { Style } from "../models"

interface ThemeStyles {
    [key: string]: Style[]
}

export const THEME_STYLES: ThemeStyles = {
    "buses-altas-cumbres": [
        { name: "primary", value: "#112497" },
        { name: "principal-texto", value: "white" },
        { name: "secondary", value: "#ff8f45" },
        { name: "barra", value: "#112497" },
        { name: "bg", value: "#142486" }
    ],
    "buses-casther": [
        { name: "primary", value: "#FF8300" },
        { name: "principal-texto", value: "white" },
        { name: "secondary", value: "#FF5403" },
        { name: "barra", value: "#FF8300" },
        { name: "bg", value: "orange" }
    ],
    "buses-erbuc": [
        { name: "background-color", value: "#168d16 !important" },
        { name: "primary", value: "#1d52a0" },
        { name: "principal-texto", value: "white" },
        { name: "secondary", value: "#033E60" },
        { name: "barra", value: "#168d16" },
        { name: "bg", value: "#51ad51" }
    ],
    "buses-expreso-del-sur": [
        { name: "primary", value: "#1d52a0" },
        { name: "principal-texto", value: "white" },
        { name: "secondary", value: "#da1818cf" },
        { name: "barra", value: "#1d52a0" },
        { name: "bg", value: "#1d52a0" }
    ],
    "buses-igillaima": [
        { name: "primary", value: "#168d16" },
        { name: "principal-texto", value: "#6732d4" },
        { name: "secondary", value: "#033E60" },
        { name: "barra", value: "#009242" },
        { name: "bg", value: "#e91e63" },
        { name: "principal-label", value: "#6a6a6a" }
    ],
    "buses-jeldres": [
        { name: "primary", value: "#168d16" },
        { name: "principal-texto", value: "white" },
        { name: "secondary", value: "#105652" },
        { name: "barra", value: "#168d16" },
        { name: "bg", value: "#51ad51" }
    ],
    "buses-paravias": [
        { name: "primary", value: "#0da25e" },
        { name: "principal-texto", value: "white" },
        { name: "secondary", value: "#1CD6CE" },
        { name: "barra", value: "#0da25e" },
        { name: "bg", value: "#0da25e" }
    ],
    "buses-pullmantur": [
        { name: "primary", value: "#4b457f" },
        { name: "principal-texto", value: "#ffffff" },
        { name: "secondary", value: "#293462" },
        { name: "barra", value: "#4b457f" },
        { name: "bg", value: "#4b457f" },
        { name: "principal-label", value: "#6a6a6a" }
    ],
    "buses-rcb": [
        { name: "primary", value: "#168d16" },
        { name: "principal-texto", value: "#6732d4" },
        { name: "secondary", value: "#033E60" },
        { name: "barra", value: "#009242" },
        { name: "bg", value: "#e91e63" },
        { name: "principal-label", value: "#6a6a6a" }
    ],
    "buses-rimar": [
        { name: "primary", value: "#A51F00" },
        { name: "principal-texto", value: "#6732d4" },
        { name: "secondary", value: "#E41F17" },
        { name: "barra", value: "#A51F00" },
        { name: "bg", value: "#e91e63" },
        { name: "principal-label", value: "#6a6a6a" }
    ],
    "buses-sanhueza": [
        { name: "background-color", value: "#168d16 !important" },
        { name: "primary", value: "#C61421" },
        { name: "principal-texto", value: "white" },
        { name: "secondary", value: "#033E60" },
        { name: "barra", value: "#168d16" },
        { name: "bg", value: "#51ad51" }
    ],
    "buses-sol-del-pacifico": [
        { name: "primary", value: "#D53331" },
        { name: "principal-texto", value: "#6732d4" },
        { name: "secondary", value: "#D53331" },
        { name: "barra", value: "#D53331" },
        { name: "bg", value: "#0d7be2" },
        { name: "principal-label", value: "#6a6a6a" }
    ],
    "buses-tra": [
        { name: "primary", value: "#3CB371" },
        { name: "principal-texto", value: "white" },
        { name: "secondary", value: "#C00000" },
        { name: "barra", value: "#C00000" },
        { name: "bg", value: "#3CB371" }
    ],
    "buses-transantin": [
        { name: "primary", value: "#1d52a0" },
        { name: "principal-texto", value: "white" },
        { name: "secondary", value: "#0F2C67" },
        { name: "barra", value: "#1d52a0" },
        { name: "bg", value: "#1d52a0" }
    ],
    "buses-viajaqui": [
        { name: "primary", value: "#00a9ef" },
        { name: "principal-texto", value: "white" },
        { name: "secondary", value: "#9bca3b" },
        { name: "barra", value: "#0da25e" },
        { name: "bg", value: "#0da25e" }
    ],
    "chi-ar": [
        { name: "primary", value: "#D53331" },
        { name: "principal-texto", value: "#6732d4" },
        { name: "secondary", value: "#D53331" },
        { name: "barra", value: "#D53331" },
        { name: "bg", value: "#0d7be2" },
        { name: "principal-label", value: "#6a6a6a" }
    ],
    "chile-pruebas": [
        { name: "primary", value: "#6732d4" },
        { name: "principal-texto", value: "#6732d4" },
        { name: "secondary", value: "#ffffff" },
        { name: "barra", value: "#EFF1F6" },
        { name: "bg", value: "#e91e63" },
        { name: "principal-label", value: "#6a6a6a" }
    ],
    "cikbus": [
        { name: "primary", value: "#ea2064" },
        { name: "principal-texto", value: "white" },
        { name: "secondary", value: "#ea2064" },
        { name: "barra", value: "#ea2064" },
        { name: "bg", value: "#1d52a0" }
    ],
    "cikbus-express": [
        { name: "primary", value: "#ea2064" },
        { name: "principal-texto", value: "white" },
        { name: "secondary", value: "#ea2064" },
        { name: "barra", value: "#ea2064" },
        { name: "bg", value: "#1d52a0" }
    ],
    "default": [
        { name: "primary", value: "#002172" },
        { name: "principal-texto", value: "#002172" },
        { name: "secondary", value: "#e52062" },
        { name: "barra", value: "#EFF1F6" },
        { name: "bg", value: "#e91e63" },
        { name: "principal-label", value: "#6a6a6a" }
    ],
    "expreso-santa-cruz": [
        { name: "primary", value: "#ea2064" },
        { name: "principal-texto", value: "white" },
        { name: "secondary", value: "#ea2064" },
        { name: "barra", value: "#ea2064" },
        { name: "bg", value: "#1d52a0" }
    ],
    "hualpen": [
        { name: "primary", value: "#FE7511" },
        { name: "principal-texto", value: "white" },
        { name: "secondary", value: "#FF5403" },
        { name: "barra", value: "#FE7511" },
        { name: "bg", value: "#ff8227" }
    ],
    "marga-taqsa": [
        { name: "primary", value: "#e67824" },
        { name: "principal-texto", value: "white" },
        { name: "secondary", value: "#fab80e" },
        { name: "barra", value: "#e67824" },
        { name: "bg", value: "#e67824" }
    ],
    "movired": [
        { name: "background-color", value: "#CE0028 !important" },
        { name: "primary", value: "#CE0028" },
        { name: "principal-texto", value: "white" },
        { name: "secondary", value: "#CE0028" },
        { name: "barra", value: "#CE0028" },
        { name: "bg", value: "#51ad51" }
    ],
    "narbus": [
        { name: "primary", value: "#168d16" },
        { name: "principal-texto", value: "#6732d4" },
        { name: "secondary", value: "#033E60" },
        { name: "barra", value: "#009242" },
        { name: "bg", value: "#e91e63" },
        { name: "principal-label", value: "#6a6a6a" }
    ],
    "pasajes": [
        { name: "primary", value: "#002172" },
        { name: "principal-texto", value: "#002172" },
        { name: "secondary", value: "#e52062" },
        { name: "barra", value: "#EFF1F6" },
        { name: "bg", value: "#e91e63" },
        { name: "principal-label", value: "#6a6a6a" }
    ],
    "pullman-jc": [
        { name: "primary", value: "#ff0000" },
        { name: "principal-texto", value: "white" },
        { name: "secondary", value: "#0a009b" },
        { name: "barra", value: "#ff0000" },
        { name: "bg", value: "#ff0000" }
    ],
    "pullman-lago-penuelas": [
        { name: "primary", value: "#064491" },
        { name: "principal-texto", value: "white" },
        { name: "secondary", value: "#fe6307" },
        { name: "barra", value: "#fe6307" },
        { name: "bg", value: "#064491" }
    ],
    "pullman-setter": [
        { name: "background-color", value: "#168d16 !important" },
        { name: "primary", value: "#261d31" },
        { name: "principal-texto", value: "white" },
        { name: "secondary", value: "#033E60" },
        { name: "barra", value: "#168d16" },
        { name: "bg", value: "#51ad51" }
    ],
    "ruta-bus-78": [
        { name: "primary", value: "#ee0f0fcf" },
        { name: "principal-texto", value: "white" },
        { name: "secondary", value: "#A71B1B" },
        { name: "barra", value: "#1d52a0" },
        { name: "bg", value: "#1d52a0" }
    ],
    "ruta78": [
        { name: "background-color", value: "#168d16 !important" },
        { name: "primary", value: "#E43E28" },
        { name: "principal-texto", value: "white" },
        { name: "secondary", value: "#033E60" },
        { name: "barra", value: "#168d16" },
        { name: "bg", value: "#51ad51" }
    ],
    "transfer-pruebas": [
        { name: "primary", value: "#6732d4" },
        { name: "principal-texto", value: "#6732d4" },
        { name: "secondary", value: "#ffffff" },
        { name: "barra", value: "#EFF1F6" },
        { name: "bg", value: "#e91e63" },
        { name: "principal-label", value: "#6a6a6a" }
    ],
    "turismo-zaahj": [
        { name: "primary", value: "#009c90" },
        { name: "principal-texto", value: "#ffffff" },
        { name: "secondary", value: "#FFD24C" },
        { name: "barra", value: "#009c90" },
        { name: "bg", value: "#009c90" },
        { name: "principal-label", value: "#6a6a6a" }
    ]
};

